// extracted by mini-css-extract-plugin
export default {"modal":"_2Jv31","root":"_1ddTv","close":"_2od1V","closeIcon":"_1fSpP"};